'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
function TakeNextChatButton(props) {
  return /*#__PURE__*/_jsx("div", {
    className: "justify-center m-top-3 m-bottom-5",
    children: /*#__PURE__*/_jsx(UIFormControl, {
      error: props.failed,
      validationMessage: props.failed ? /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "all-chats-taken-message",
        message: "app.card.queue.alert.message"
      }) : null,
      children: /*#__PURE__*/_jsx(UILoadingButton, {
        "data-test-id": "take-next-chat-button-internal",
        disabled: props.disabled,
        onClick: props.onClick,
        size: "small",
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "take-next-chat-button-label",
          message: "app.card.queue.button.label"
        })
      })
    })
  });
}
TakeNextChatButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  failed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
export default TakeNextChatButton;